var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mobile-padding"},[_c('h1',{staticClass:"page-title"},[_vm._v(" "+_vm._s(_vm.$t('RETURN_BY_QIWI_WALLET.TITLE'))+" ")]),_c('step-list',{attrs:{"steps":_vm.steps}}),_c('div',{staticClass:"sf-mv-l"},[_c('payment-methods',{attrs:{"inline":true,"hidden-methods":[_vm.paymentMethod]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }